import { render, staticRenderFns } from "./integrations-logo.vue?vue&type=template&id=6d825458&"
import script from "./integrations-logo.vue?vue&type=script&lang=js&"
export * from "./integrations-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports